export default __webpack_public_path__ + "static/media/p2.82c9a518.png";